import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a6378ee6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "object-item" }
const _hoisted_2 = { class: "object-item__title no-h-styling" }
const _hoisted_3 = { class: "object-item__info" }
const _hoisted_4 = { class: "tender-field-title" }
const _hoisted_5 = { class: "tender-field-info" }
const _hoisted_6 = { class: "object-item__info" }
const _hoisted_7 = { class: "tender-field-title" }
const _hoisted_8 = { class: "tender-field-info" }
const _hoisted_9 = { class: "object-item__info" }
const _hoisted_10 = { class: "tender-field-title" }
const _hoisted_11 = { class: "tender-field-info" }
const _hoisted_12 = { class: "object-item__info" }
const _hoisted_13 = { class: "tender-field-title" }
const _hoisted_14 = { class: "tender-field-info" }
const _hoisted_15 = { class: "object-item__category" }
const _hoisted_16 = { class: "tender-field-title" }
const _hoisted_17 = { class: "object-item__category-text" }
const _hoisted_18 = {
  key: 0,
  class: "object-item__description"
}
const _hoisted_19 = { class: "tender-field-title tender-field-title__description" }
const _hoisted_20 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.lot.name), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.headerText(_ctx.$t("tender_details.lots_price"))), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(`${_ctx.lot.price.toLocaleString("en-US", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          })} ${_ctx.lot.currency}`), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.headerText(_ctx.$t("tender_details.lots_quantity"))), 1),
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.lot.quantity), 1)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.headerText(_ctx.$t("tender_details.lots_units"))), 1),
      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.lot.unit), 1)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.headerText(_ctx.$t("tender_details.lots_amount"))), 1),
      _createElementVNode("div", _hoisted_14, _toDisplayString(`${_ctx.lot.amount.toLocaleString("en-US", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          })} ${_ctx.lot.currency}`), 1)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("tender_details.category")), 1),
      _createElementVNode("div", _hoisted_17, _toDisplayString(!!_ctx.lot.category_code ? _ctx.categoryTitle : '–'), 1)
    ]),
    (!!_ctx.lot.description)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("tender_details.description")), 1),
          _createElementVNode("div", {
            innerHTML: _ctx.lot.description.replaceAll('\n\n', '<br>'),
            class: "object-item__description-text"
          }, null, 8, _hoisted_20)
        ]))
      : _createCommentVNode("", true)
  ]))
}